import React, { useContext, useState } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';

import { MarkerType } from 'types/marker';
import { DimensionsContext } from 'context/DimensionsContext';
import { PopupMenu } from '../reusable/PopupMenu';

type PropsType = {
  marker: MarkerType;
  navigate: (location: object) => void;
  close: () => void;
  addDestination: (marker: MarkerType) => void;
  open: boolean;
};

const testID = 'MarkerPopup';

const ResponsiveImage = ({ uri, style }) => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [desiredHeight, setDesiredHeight] = React.useState(0);

  Image.getSize(uri, (width, height) => {
    setDesiredHeight((size.width / width) * height);
  });

  const styles = StyleSheet.create({
    ...style,
    image: {
      width: '100%',
      height: desiredHeight,
    },
  });

  return (
    <View
      onLayout={(e) => {
        setSize({ ...e.nativeEvent.layout });
      }}
      style={styles.imageContainer}
    >
      <Image source={{ uri }} resizeMode="contain" style={styles.image} />
    </View>
  );
};

export function MarkerPopup(props: PropsType) {
  const dimensions = useContext(DimensionsContext);
  const { marker, close, addDestination, open } = props;
  const style = dimensions.size === 'large' ? desktopStyles : styles;

  return (
    <PopupMenu
      title={marker?.title}
      testID={testID}
      close={() => close()}
      addDestination={() => addDestination(marker)}
      id="marker"
      open={open}
    >
      <View>
        {marker?.image && <ResponsiveImage uri={marker?.image} style={style} />}
        {marker?.description && (
          <Text testID={`${testID}_description`}>{marker?.description}</Text>
        )}
      </View>
    </PopupMenu>
  );
}

const desktopStyles = StyleSheet.create({
  container: {
    overflowY: 'auto',
    flex: 1,
  },
  title: {
    fontSize: 30,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  button: {
    alignSelf: 'flex-end',
    marginTop: 20,
  },
  imageContainer: {
    marginBottom: 20,
  },
});

const styles = StyleSheet.create({
  container: {
    overflowY: 'auto',
    flex: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  button: {
    position: 'absolute',
    top: -30,
    right: 10,
  },
  imageContainer: {
    marginBottom: 10,
  },
});
